export enum Events {
  INCREMENT_MUTATION = "INCREMENT_MUTATION",
  DECREMENT_MUTATION = "DECREMENT_MUTATION",
}
